import React from 'react'
import AdminBillingAccountDetailContext from './context'
import AdminPracticeTable from 'components/AdminPracticeTable'
import { GridColumnVisibilityModel, GridRowId, GridSortModel } from '@mui/x-data-grid-pro'

const AdminBillingAccountDetailPractices: React.FC = () => {
    const {
        practiceSearchForm,
        updatePracticeSearchForm,
    } = React.useContext(AdminBillingAccountDetailContext)

    const [practiceSelection, setPracticeSelection] = React.useState<GridRowId[]>([])
    const [practiceColumnVisibilityModel, setPracticeColumnVisibilityModel] = React.useState<GridColumnVisibilityModel>({})
    const [practiceSortModel, setPracticeSortModel] = React.useState<GridSortModel>([])
    
    return (
        <AdminPracticeTable 
            form={practiceSearchForm}
            updateForm={updatePracticeSearchForm}
            selection={practiceSelection}
            setSelection={setPracticeSelection}
            columnVisibilityModel={practiceColumnVisibilityModel}
            setColumnVisibilityModel={setPracticeColumnVisibilityModel}
            sortModel={practiceSortModel}
            setSortModel={setPracticeSortModel}
        />
    )
}

export default AdminBillingAccountDetailPractices